module.exports = __webpack_public_path__ + "img/08c-osm-solicitacao-recusar.7887e91b.png";